import PageWrapper from '#/components/Layout/PageWrapper/PageWrapper';
import ProtectedRoute from '#/components/Router/ProtectedRoute/ProtectedRoute';
import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { ROUTE_NAMES } from './routes';
import Login from '#/views/Login';
import Home from '#/views/Home';
import Artist from '#/views/Artist';
import Discography from '#/views/Artist/views/Discography';
import RelatedArtists from '#/views/Artist/views/RelatedArtists';
import AppearsOn from '#/views/Artist/views/AppearsOn';
import Album from '#/views/Album';
import Track from '#/views/Track';
import Playlist from '#/views/Playlist';
import Search from '#/views/Search';
import UserProfile from '#/views/UserProfile';
import Following from '#/views/UserProfile/views/Following/Following';

const router = createBrowserRouter([
  {
    path: ROUTE_NAMES.HOME,
    element: <PageWrapper />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [
          {
            index: true,
            element: <Home />,
          },
          {
            path: `${ROUTE_NAMES.ARTIST}/:id`,
            children: [
              {
                index: true,
                element: <Artist />,
              },
              {
                path: `${ROUTE_NAMES.ARTIST}/:id/discography`,
                element: <Discography />,
              },
              {
                path: `${ROUTE_NAMES.ARTIST}/:id/related`,
                element: <RelatedArtists />,
              },
              {
                path: `${ROUTE_NAMES.ARTIST}/:id/appears-on`,
                element: <AppearsOn />,
              },
            ],
          },
          {
            path: `${ROUTE_NAMES.ALBUM}/:id`,
            element: <Album />,
          },
          {
            path: `${ROUTE_NAMES.TRACK}/:id`,
            element: <Track />,
          },
          {
            path: `${ROUTE_NAMES.PLAYLIST}/:id`,
            element: <Playlist />,
          },
          {
            path: `${ROUTE_NAMES.SEARCH}`,
            element: <Search />,
          },
          {
            path: `${ROUTE_NAMES.PROFILE}`,
            children: [
              {
                index: true,
                element: <UserProfile />,
              },
              {
                path: ROUTE_NAMES.PROFILE_FOLLOWING,
                element: <Following />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/login',
    element: <Login />,
  },
]);

export default router;
